<!-- ── PREDICTIVE FOREIGN EXCHANGE CALCULATOR ── -->
<app-ip-shell
  [activeStep]="1"
  [showStepper]="false"
  calculatorName="Predictive Foreign Exchange">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Predictive Foreign Exchange</div>
      <h1 class="ip-form-head__title">Model your FX returns</h1>
      <p class="ip-form-head__subtitle">
        See how currency appreciation in your home currency amplifies your UK property investment returns over time.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Property Value -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="InvestmentGBP">Property value</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK avg: £280k</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="InvestmentGBP"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 280,000"
            [(ngModel)]="InvestmentGBP"
            (keyup)="InvestmentGBP=validation.amountWithComma(InvestmentGBP); calcLive()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Home Currency -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label">Home currency</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Returns shown in your currency</span>
        </div>
        <div class="s3-currency-wrap">
          <button
            type="button"
            class="s3-currency-btn"
            [class.open]="currencyDropdownOpen"
            [class.error-input]="homeCurrencyError"
            (click)="currencyDropdownOpen=!currencyDropdownOpen">
            <span class="s3-currency-val" [class.placeholder]="!selectedCurrencyCode">
              {{ selectedCurrencyCode ? getCurrencyLabel(selectedCurrencyCode) : 'Select currency' }}
            </span>
            <svg class="s3-currency-chevron" [class.rotated]="currencyDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
          <div class="s3-dropdown" *ngIf="currencyDropdownOpen">
            <div class="s3-dropdown__search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <input type="text" class="s3-dropdown__input" placeholder="Search currency..." [(ngModel)]="currencySearch" autocomplete="off" (click)="$event.stopPropagation()">
            </div>
            <div class="s3-dropdown__list">
              <div
                *ngFor="let c of getFilteredCurrencies()"
                class="s3-dropdown__item"
                [class.selected]="c.code === selectedCurrencyCode"
                (click)="onCurrencySelect2(c.code)">
                <span class="s3-dropdown__item-name">{{ c.name }}</span>
                <span class="s3-dropdown__item-code">{{ c.code }}</span>
              </div>
              <div class="s3-dropdown__empty" *ngIf="getFilteredCurrencies().length === 0">No currencies found</div>
            </div>
          </div>
        </div>
        <p class="ip-field-error" *ngIf="homeCurrencyError">This field is required</p>
      </div>

      <!-- FX Rate -->
      <div class="ip-field" *ngIf="selectedCurrencyCode">
        <div class="ip-field__head">
          <label class="ip-field__label">FX rate (1 GBP)</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Auto-filled from live rate</span>
        </div>
        <div class="ip-input">
          <input
            type="number"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 106.5"
            step="0.01" min="0"
            [(ngModel)]="homecurrency"
            (input)="calcLive()">
          <span class="ip-input__suffix">{{ selectedCurrencyCode }}</span>
        </div>
      </div>

      <!-- FX Appreciation -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="FXGrowth">FX appreciation p.a.</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>GBP/INR historical: 2–4%</span>
        </div>
        <div class="ip-input">
          <input
            type="number"
            id="FXGrowth"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 4"
            step="0.1" min="0" max="50"
            [(ngModel)]="FXGrowth"
            (input)="calcLive()">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- Projection Period -->
      <div class="ip-field">
        <label class="ip-field__label">Projection period</label>
        <div class="ip-chip-row">
          <button
            *ngFor="let y of periodOptions"
            class="ip-chip"
            [class.is-active]="investedTenure===y"
            (click)="investedTenure=y; calcLive()"
            type="button">{{ y }} yrs</button>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/predictive-foreign-exchange/step1']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--accent" type="button" (click)="next()">
        Calculate Returns
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL — live FX preview ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ locationName }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag is-uk">
          {{ selectedCurrencyCode || 'GBP' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">

        <!-- Today -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Today</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">{{ livePrice ? ('£' + (livePrice | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="selectedCurrencyCode">
            <span class="ip-rs-row__key">£1 =</span>
            <span class="ip-rs-row__val">{{ liveRate ? ((liveRate | number:'1.1-2') + ' ' + selectedCurrencyCode) : '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="liveInitHome">
            <span class="ip-rs-row__key">In {{ selectedCurrencyCode }}</span>
            <span class="ip-rs-row__val">{{ formatHomeCurrency(liveInitHome) }}</span>
          </div>
        </div>

        <!-- Exit -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Exit ({{ livePeriod }} yr)</span>
            <span class="ip-rs-section__total">{{ liveExitHome ? formatHomeCurrency(liveExitHome) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Exit FX rate</span>
            <span class="ip-rs-row__val">{{ liveExitRate ? ((liveExitRate | number:'1.1-2') + ' ' + selectedCurrencyCode) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">FX appreciation</span>
            <span class="ip-rs-row__val">{{ liveAppreciation ? (liveAppreciation + '% p.a.') : '—' }}</span>
          </div>
        </div>

        <!-- FX Boost -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">FX Boost</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Extra gain in {{ selectedCurrencyCode || '—' }}</span>
            <span class="ip-rs-row__val">{{ liveFxBoost ? ('+' + formatHomeCurrency(liveFxBoost)) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">FX growth</span>
            <span class="ip-rs-row__val">{{ liveFxGrowthPct ? ('+' + (liveFxGrowthPct | number:'1.1-1') + '%') : '—' }}</span>
          </div>
        </div>

      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">FX boost over {{ livePeriod }} yrs</div>
        <div class="ip-rail-summary__outlay-value">{{ liveFxBoost ? ('+' + formatHomeCurrency(liveFxBoost)) : '—' }}</div>
        <div class="ip-rail-summary__outlay-meta">{{ liveFxGrowthPct ? ((liveFxGrowthPct | number:'1.1-1') + '% currency gain') : 'Enter values to preview' }}</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
